export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/signature.5cf428e.svg";